import { createAuthClient } from "better-auth/react";

import { config } from "./config";

/**
 * Get the base URL for authentication requests based on the current environment
 *
 * Environment-specific behavior:
 * - Development: Uses Vite proxy (localhost:3002/v2/auth -> localhost:3000/v2/auth)
 * - Staging/Production: Direct API calls to the configured API URL
 */
function getBaseUrl() {
  if (config.isDevelopment) {
    // In development, use Vite proxy to avoid CORS issues
    const devUrl = `${config.webUrl}/v2/auth`;
    console.log("🔐 Auth client using development proxy URL:", devUrl);
    return devUrl;
  }

  // In staging/production, call API directly
  const authUrl = `${config.apiUrl}/v2/auth`;
  console.log("🔐 Auth client using direct API URL:", authUrl);
  return authUrl;
}

export const authClient = createAuthClient({
  baseURL: getBaseUrl(),
});
